<ion-menu side="start" type="push" menuId="mainMenu" contentId="main" type="overlay">
  <app-nav-menu></app-nav-menu>
</ion-menu>